module.exports = __webpack_public_path__ + "img/icon2.75820618.svg";